module.exports = __webpack_public_path__ + "img/clock.cd7d7fdf.svg";